import axios from 'axios';

const getFirmLogoBySlug = (slug, alias) =>
  axios.get(`/firms/get_firm_logo_by_slug`, {
    params: {
      alias,
      slug,
    },
  });
const downloadFirmZipFolder = perCompany =>
  axios.get(`/firms/download_firm_zip_folder?per_company=${perCompany}`);

const getFirmFaviconBySlug = (slug, alias) =>
  axios.get(`/firms/get_firm_favicon_by_slug`, {
    params: {
      alias,
      slug,
    },
  });
const isSignInWithPhoneNumberEnabled = (slug, alias) =>
  axios.get(`/firms/is_sign_in_with_phone_number_enabled`, {
    params: {
      alias,
      slug,
    },
  });
const showSignInImageBySlug = (slug, alias) =>
  axios.get(`/firms/show_sign_in_image_by_slug`, {
    params: {
      alias,
      slug,
    },
  });
const updateDemoTaxSoftware = taxSoftware =>
  axios.get(`/firms/update_demo_tax_software?tax_software=${taxSoftware}`);
const getAllUsers = () => axios.get('/firms/all_users');
const getUsageStatistics = year =>
  axios.get(`/firms/get_usage_statistics?year=${year}`);
const getBillingCycles = firm => axios.get(`/firms/${firm.id}/billing_cycles`);
const getAllClients = () => axios.get('/firms/all_clients');
const getAllLinkedAccounts = () => axios.get('/firms/all_linked_accounts');
const getAllEntityTypes = () => axios.get('/firms/all_entity_types');
const getCurrentUserFirm = () => axios.get('/firms/current_user_firm');
const updateCurrentUserFirmLogo = params =>
  axios.post('/firms/update_firm_logo', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
const getFirmReportTemplates = () =>
  axios.get('/firms/get_firm_report_templates');

const addClientTag = newTag =>
  axios.post('/firms/add_client_tag', {
    new_tag: newTag,
  });
const removeClientTag = tagId =>
  axios.post('/firms/remove_client_tag', {
    tag_id: tagId,
  });
const addEntityTag = newTag =>
  axios.post('/firms/add_entity_tag', {
    new_tag: newTag,
  });
const removeEntityTag = tagId =>
  axios.post('/firms/remove_entity_tag', {
    tag_id: tagId,
  });

const addDocumentTag = newTag =>
  axios.get(`/firms/add_document_tag?name=${newTag}`);
const removeDocumentTag = tagToDelete =>
  axios.get(`/firms/remove_document_tag?name=${tagToDelete}`);

const addGroup = newGroupName =>
  axios.post('/firms/add_group', {
    new_group_name: newGroupName,
  });
const updateGroup = ({ groupId, newGroupName }) =>
  axios.post('/firms/update_group', {
    firm_group_id: groupId,
    new_group_name: newGroupName,
  });
const removeGroup = groupId =>
  axios.post('/firms/remove_group', {
    firm_group_id: groupId,
  });
const updateCurrentUserFirm = firm => axios.post('/firms/update_firm', firm);
const updateCurrentUserPreferences = firm =>
  axios.post('/firms/update_preferences', firm);

const getFirmVocabs = firmId => axios.get(`/firms/${firmId}/firm_vocabs`);
const createGlossaryVocab = ({ firmId, description, key_words }) =>
  axios.post(`/firms/${firmId}/firm_vocabs`, { description, key_words });
const updateGlossaryVocab = ({ firmId, id, description, key_words }) =>
  axios.put(`/firms/${firmId}/firm_vocabs/${id}`, { description, key_words });
const deleteGlossaryVocab = ({ firmId, id }) =>
  axios.delete(`/firms/${firmId}/firm_vocabs/${id}`);
const inviteFirmUser = ({
  email,
  firstName,
  lastName,
  phoneNumber,
  access,
  userIds,
  groupId,
}) =>
  axios.post('/firms/invite_firm_user', {
    email,
    access,
    phone_number: phoneNumber,
    fname: firstName,
    lname: lastName,
    user_ids: userIds,
    firm_group_id: groupId,
  });

const getCustomStatuses = firmId =>
  axios.get(`/firms/${firmId}/firm_custom_statuses`);
const addCustomStatus = ({
  firmId,
  clientDisplayStatus,
  firmUserDisplayStatus,
  clientInstruction,
}) =>
  axios.post(`/firms/${firmId}/firm_custom_statuses`, {
    client_display_status: clientDisplayStatus,
    firm_user_display_status: firmUserDisplayStatus,
    client_instruction: clientInstruction,
  });
const updateCustomStatus = ({
  firmId,
  id,
  clientDisplayStatus,
  firmUserDisplayStatus,
  clientInstruction,
}) =>
  axios.put(`/firms/${firmId}/firm_custom_statuses/${id}`, {
    client_display_status: clientDisplayStatus,
    firm_user_display_status: firmUserDisplayStatus,
    client_instruction: clientInstruction,
  });
const deleteCustomStatus = ({ firmId, id }) =>
  axios.delete(`/firms/${firmId}/firm_custom_statuses/${id}`);
const getAllExportTasks = () => axios.get('/firms/get_all_export_tasks');

const getFirmOnboardingStatus = () => axios.get(`/firms/onboarding_status`);
const getCustomFormNames = ({ firmId }) => {
  return axios.get(`/firms/${firmId}/firm_custom_form_names`);
};
const addCustomFormName = ({ firmId, name }) => {
  return axios.post(`/firms/${firmId}/firm_custom_form_names`, {
    name,
  });
};
const deleteCustomFormName = ({ firmId, id }) => {
  return axios.delete(`/firms/${firmId}/firm_custom_form_names/${id}`);
};
const updateCustomFormName = ({ firmId, id, ...params }) => {
  return axios.patch(`/firms/${firmId}/firm_custom_form_names/${id}`, params);
};
const getInitialSignatures = ({ firmId, id, companyId }) => {
  return axios.get(
    `/firms/${firmId}/firm_custom_form_names/${id}/get_initial_signatures`,
    {
      params: {
        company_id: companyId,
      },
    },
  );
};
const getCustomPaymentNames = ({ firmId }) => {
  return axios.get(`/firms/${firmId}/firm_custom_payment_names`);
};
const addCustomPaymentName = ({ firmId, name }) => {
  return axios.post(`/firms/${firmId}/firm_custom_payment_names`, {
    name,
  });
};
const deleteCustomPaymentName = ({ firmId, id }) => {
  return axios.delete(`/firms/${firmId}/firm_custom_payment_names/${id}`);
};

const getCustomPaperFiledReturnNames = ({ firmId }) => {
  return axios.get(`/firms/${firmId}/firm_custom_paper_filed_return_names`);
};
const addCustomPaperFiledReturnName = ({ firmId, name }) => {
  return axios.post(`/firms/${firmId}/firm_custom_paper_filed_return_names`, {
    name,
  });
};
const deleteCustomPaperFiledReturnName = ({ firmId, id }) => {
  return axios.delete(
    `/firms/${firmId}/firm_custom_paper_filed_return_names/${id}`,
  );
};

export default {
  getFirmLogoBySlug,
  getFirmOnboardingStatus,
  getFirmFaviconBySlug,
  isSignInWithPhoneNumberEnabled,
  getAllLinkedAccounts,
  getAllUsers,
  getAllClients,
  getAllEntityTypes,
  getCurrentUserFirm,
  showSignInImageBySlug,
  updateCurrentUserFirm,
  updateCurrentUserFirmLogo,
  updateCurrentUserPreferences,
  addClientTag,
  removeClientTag,
  addEntityTag,
  removeEntityTag,
  addDocumentTag,
  removeDocumentTag,
  addGroup,
  removeGroup,
  updateGroup,
  getFirmReportTemplates,
  getFirmVocabs,
  createGlossaryVocab,
  updateGlossaryVocab,
  deleteGlossaryVocab,
  inviteFirmUser,
  updateDemoTaxSoftware,
  getUsageStatistics,
  getBillingCycles,
  getCustomStatuses,
  addCustomStatus,
  updateCustomStatus,
  deleteCustomStatus,
  getAllExportTasks,
  getCustomFormNames,
  addCustomFormName,
  deleteCustomFormName,
  updateCustomFormName,
  getCustomPaymentNames,
  addCustomPaymentName,
  deleteCustomPaymentName,
  getInitialSignatures,
  getCustomPaperFiledReturnNames,
  addCustomPaperFiledReturnName,
  deleteCustomPaperFiledReturnName,
  downloadFirmZipFolder,
};
